"use client";
import React, { useEffect, useState } from "react";
import * as Toast from "@radix-ui/react-toast";
import { useSelector } from "react-redux";
import { Text } from "@radix-ui/themes";
import { RootState } from "../redux/store";
import { ActionMessage } from "../services/modelService";

interface ToastProps {
  title: string;
  message: string;
  isOpen: boolean;
  handleToast: any;
}

const ToastMessage: React.FC<ToastProps> = (props) => {
  const [isOpen, setOpenStatus] = useState<boolean>(false);
  const [information, setInformation] = useState<ActionMessage | null>(null);

  const messageChange = useSelector(
    (state: RootState) => state.toastReducer.message
  );

  useEffect(() => {
    if (messageChange.description) {
      setInformation(messageChange);
      setOpenStatus(true);
    }
  }, [messageChange]);

  return (
    <Toast.Provider  swipeDirection="right" duration={4000}>
      <Toast.Root
        className="ToastRoot"
        open={isOpen || props.isOpen}
        onOpenChange={() => {
          props.handleToast ? props.handleToast() : null;
          setOpenStatus(false);
        }}
      >
        <Toast.Description>
          <Text className="ToastDescription">
            {props.message || information?.description || ""}
          </Text>
        </Toast.Description>
        <Toast.Action
          className="ToastAction"
          asChild
          altText="Goto schedule to undo"
        >
          <button className="inline-flex items-center justify-center rounded font-medium text-xs px-[10px] leading-[25px] h-[25px] bg-primary-default2 text-primary-default11 shadow-[inset_0_0_0_1px] shadow-primary-default7 hover:shadow-[inset_0_0_0_1px] hover:shadow-primary-default8 focus:shadow-[0_0_0_2px] focus:shadow-primary-default8 hover:text-white">
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>
        </Toast.Action>
      </Toast.Root>
      <Toast.Viewport className="ToastViewport" />
    </Toast.Provider>
  );
};

export default ToastMessage;
